import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';
import { InputDriver } from '../Input/Input.driver';
import { CalendarDriver } from '../Calendar/Calendar.driver';

export interface DatePickerDriver extends BaseDriver {
  driver: {
    exists: () => boolean;
    open: () => ReturnType<InputDriver['focus']>;
    clickOutside: () => void;
  };
  inputDriver: InputDriver;
  calendarDriver: CalendarDriver;
}
